import React from "react";
import { Button } from "reactstrap";
import cx from "classnames";
import PropTypes from "prop-types";
import useGoogleLogin from "../../hooks/useGoogleLogin";

import GoogleIcon from "../../assets/images/google-logo.svg";

import global from "../../scss/dhp.scss";
import { JOIN_COMPANY, SIGNIN, SIGNUP } from "../../constants/user";

let style = Object.assign({}, global);

const GoogleButton = ({ label, mod, invitationToken, companyid }) => {
  const { login, joinCompany } = useGoogleLogin(mod);

  const googleAuthenticate = () => {
    if (process.env.MAINTENANCE) return;
    if ([SIGNIN, SIGNUP].includes(mod)) login();
    if (mod === JOIN_COMPANY) joinCompany(invitationToken, companyid);
  };
  return (
    <div className={style["mb-3"]}>
      <Button
        type="button"
        color=""
        className={cx(style["w-100"], style["btn-border"], style["google-btn"], {
          [style["disable"]]: process.env.MAINTENANCE,
        })}
        onClick={googleAuthenticate}>
        <img src={GoogleIcon} alt="Google Icon" className={style["pr-3"]} />
        <span className={cx(style["fw-6"], style["color-black"])}>{label}</span>
      </Button>
    </div>
  );
};

GoogleButton.propTypes = {
  label: PropTypes.string.isRequired,
  mod: PropTypes.string.isRequired,
  invitationToken: PropTypes.string,
  companyid: PropTypes.string,
};

export default GoogleButton;
